<template>
  <div v-if="HeadData">
    <nav ref="header" class="navbar navbar-expand-xl nav_awards" :class="{ 'change_bg': isParentActive }">

      <a class="accesskey_go" href="#accesskey_c" title="跳到中間主要內容區">
        跳到中間主要內容區
      </a>

      <a accesskey="u" id="accesskey_u" href="#" title="上方區塊">
        :::
      </a>
      <div class="container">
        <div class="logo_box">
          <router-link class="navbar-brand" to="/"
            title="GMA (Golden Melody Awards & Festival) 含括金曲獎頒獎典禮及金曲國際音樂節等兩大活動。">
            <h1>
              <!-- <img :src="HeadData.SiteLogo" alt="GMA logo" v-if="HeadData.SiteLogo"> -->
              <img src="img/GMAlogo.svg" alt="GMA logo" v-if="HeadData.SiteLogo">
              <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
            </h1>
          </router-link>
        </div>
        <div class="menu_box">
          <button @click="closureMenu" class="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="line1"></span>
            <span class="line2"></span>
            <span class="line3"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarToggleExternalContent">
            <div class="box">
              <ul class="navbar-nav menu">
                <li class="nav-item" v-for="(item, index) in menuItems" :key="index">
                  <a role="button" class="nav-link" href="#" @click.prevent="toggleMenuItem(index)" :title="item.title"
                    :aria-expanded="isMenuItemVisible[index] ? 'true' : 'false'" :aria-controls="'submenu_' + index"
                    :class="{ 'active': activeIndex === index }">{{ item.title }}</a>
                  <transition name="menuList">
                    <ul v-if="isMenuItemVisible[index]" :id="'submenu_' + index"
                      :class="['menu_list', { 'change_menu': activeIndex === 1 }]" role="region"
                      :aria-label="item.title + ' 子選單'">
                      <div class="container">
                        <li v-for="(subItem, subIndex) in item.subMenu" :key="subIndex">
                          <a :href="getLink(subItem.to)" class="title"
                            :target="subItem.to.Type == 3 && subItem.to.Blank ? '_blank' : ''"
                            :title="subItem.title + (subItem.to.Type == 3 && subItem.to.Blank ? ', 另開新視窗' : '')"
                            @click="closureMenu()">{{
                              subItem.title
                            }}</a>
                          <a :href="getLink(subSubItem.to)"
                            :target="subSubItem.to.Type == 3 && subSubItem.to.Blank ? '_blank' : ''"
                            v-for="(subSubItem, subSubIndex) in subItem.subSubMenu" :key="subSubIndex"
                            :title="subSubItem.title + (subSubItem.to.Type == 3 && subSubItem.to.Blank ? ', 另開新視窗' : '')"
                            @click="closureMenu()">{{
                              subSubItem.title }}</a>
                        </li>
                        <div class="closure_box">
                          <button @click="closureMenuItem" class="closure_btn" aria-label="關閉選單"
                            @focusout="closureMenuItem">X</button>
                        </div>
                      </div>
                    </ul>
                  </transition>
                </li>
              </ul>
              <!-- 右上選單 -->
              <div class="submenu">
                <div class="submenu_list" v-if="HeadData.RightTop_Menu">
                  <a :href="getLink(MenuData.Menu)"
                    :target="MenuData.Menu.Type == 3 && MenuData.Menu.Blank ? '_blank' : ''"
                    v-for="(MenuData, index) in HeadData.RightTop_Menu" :key="index"
                    :title="MenuData.Menu.Title + (MenuData.Menu.Type == 3 && MenuData.Menu.Blank ? ', 另開新視窗' : '')">{{
                      MenuData.Menu.Title }}</a>
                </div>
                <div class="language_box">
                  <button :class="{ 'active': local == 'zh_tw' }" @click="changeLang('zh_tw')">中文</button>
                  <button :class="{ 'active': local == 'en' }" @click="changeLang('en')">ENG</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div ref="target" class="nav_hight"></div>
    <!-- 浮動選單 -->
    <!-- <ul :class="['float_menu', { 'add': isFloat }]" v-if="HeadData.Right_Menu">
      <li v-for="(MenuData, index) in HeadData.Right_Menu" :key="index">
        <a  :href="getLink(MenuData.Menu)" :target="MenuData.Menu.Type == 3 && MenuData.Menu.Blank ? '_blank' : ''"
          :title="MenuData.Menu.Title + (MenuData.Menu.Type == 3 && MenuData.Menu.Blank ? ', 另開新視窗' : '')">
          <img :src="HeadData.SiteUrl + MenuData.Menu.Image" :alt="MenuData.Menu.Title">
        </a>
      </li>
    </ul> -->
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

//import { Fragment } from 'vue-fragment'

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "HeadBlock",
  i18n,
  components: {
    //Fragment,
    Slick,
  },
  data() {
    return {
      HeadData: null,
      menuItems: null,
      isMenuItemVisible: [],
      activeIndex: null,
      isParentActive: false,
      isFloat: false,
      local: "zh_tw",
    };
  },
  created: function () {
    // Vue.axios
    //   .get(
    //     this.$store.state.src + this.$store.state.subDirectory + "/Html/Head",
    //     {
    //       params: {
    //         lang: $cookies.get("gma_the_site_lang")
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     this.HeadData = response.data;
    //     this.menuItems = this.HeadData.Header_Menu;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });    
    if ($cookies.get("gma_the_site_lang") == "zh_tw") {
      this.HeadData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "Header_Menu": [
          {
            "title": "金曲獎頒獎典禮",
            "subMenu": [
              {
                "title": "頒獎典禮",
                "to": {
                  "MLIId": 148,
                  "MLId": 15,
                  "Id": "76623ec0-ff83-4edf-981a-5a7264055fcc",
                  "ParentId": "202534c5-ad56-429c-bc42-bc3f52639d51",
                  "Title": "頒獎典禮",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 3,
                  "CId": -1,
                  "PId": 341,
                  "Url": "/gma/36th/#/Awards",
                  "Blank": false,
                  "Sort": 2,
                  "CreateTime": "2025-04-14T20:52:46.04",
                  "LastEditTime": "2025-07-16T10:07:18.983",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "贈票辦法",
                    "to": {
                      "MLIId": 149,
                      "MLId": 15,
                      "Id": "96bc9704-3812-4176-9d70-67f6125cf6a1",
                      "ParentId": "76623ec0-ff83-4edf-981a-5a7264055fcc",
                      "Title": "贈票辦法",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 2,
                      "CId": -1,
                      "PId": 382,
                      "Url": "",
                      "Blank": false,
                      "Sort": 3,
                      "CreateTime": "2025-04-14T21:01:50.977",
                      "LastEditTime": "2025-07-16T10:07:18.987",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "入場須知",
                    "to": {
                      "MLIId": 150,
                      "MLId": 15,
                      "Id": "77d24eaa-8f98-4543-8f4f-73dd19dd6f40",
                      "ParentId": "76623ec0-ff83-4edf-981a-5a7264055fcc",
                      "Title": "入場須知",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 2,
                      "CId": -1,
                      "PId": 344,
                      "Url": "",
                      "Blank": false,
                      "Sort": 4,
                      "CreateTime": "2025-04-14T21:01:52.367",
                      "LastEditTime": "2025-07-16T10:07:18.993",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "金曲直播",
                    "to": {
                      "MLIId": 159,
                      "MLId": 15,
                      "Id": "21d97406-bb94-4cd9-9d55-c369fc684db1",
                      "ParentId": "76623ec0-ff83-4edf-981a-5a7264055fcc",
                      "Title": "金曲直播",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 73,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 5,
                      "CreateTime": "2025-04-15T09:08:17.663",
                      "LastEditTime": "2025-07-16T10:07:19",
                      "IsWinner": false
                    }
                  }
                ]
              },
              {
                "title": "入圍&得獎",
                "to": {
                  "MLIId": 151,
                  "MLId": 15,
                  "Id": "b5720528-d824-4e15-bbc0-334b161b7671",
                  "ParentId": "202534c5-ad56-429c-bc42-bc3f52639d51",
                  "Title": "入圍&得獎",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 0,
                  "CId": -1,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 6,
                  "CreateTime": "2025-04-14T21:03:15.937",
                  "LastEditTime": "2025-07-16T10:07:19.007",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "第36屆金曲獎入圍名單",
                    "to": {
                      "MLIId": 152,
                      "MLId": 15,
                      "Id": "a1fe0bd4-654c-466e-9bcc-f96f867673f4",
                      "ParentId": "b5720528-d824-4e15-bbc0-334b161b7671",
                      "Title": "第36屆金曲獎入圍名單",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 3,
                      "CId": -1,
                      "PId": -1,
                      "Url": "/gma/36th/#/Awards/AwardWinners",
                      "Blank": false,
                      "Sort": 7,
                      "CreateTime": "2025-04-14T21:03:28.783",
                      "LastEditTime": "2025-07-16T10:07:19.01",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "歷屆得獎名單",
                    "to": {
                      "MLIId": 153,
                      "MLId": 15,
                      "Id": "32745b1d-b00e-4660-be89-07d18a3f65d8",
                      "ParentId": "b5720528-d824-4e15-bbc0-334b161b7671",
                      "Title": "歷屆得獎名單",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 48,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 8,
                      "CreateTime": "2025-04-14T21:03:29.54",
                      "LastEditTime": "2025-07-16T10:07:19.017",
                      "IsWinner": false
                    }
                  }
                ]
              },
              {
                "title": "影音專區",
                "to": {
                  "MLIId": 154,
                  "MLId": 15,
                  "Id": "d292d409-2a17-4b7e-b4f8-9d247ed3d472",
                  "ParentId": "202534c5-ad56-429c-bc42-bc3f52639d51",
                  "Title": "影音專區",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 0,
                  "CId": -1,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 9,
                  "CreateTime": "2025-04-14T21:05:01.157",
                  "LastEditTime": "2025-07-16T10:07:19.023",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "預告花絮",
                    "to": {
                      "MLIId": 178,
                      "MLId": 15,
                      "Id": "d01e0f64-af04-4321-b755-7f83a0543293",
                      "ParentId": "d292d409-2a17-4b7e-b4f8-9d247ed3d472",
                      "Title": "預告花絮",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 77,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 11,
                      "CreateTime": "2025-04-15T16:26:36.663",
                      "LastEditTime": "2025-07-16T10:07:19.033",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "GMA Heat 入圍者特輯",
                    "to": {
                      "MLIId": 179,
                      "MLId": 15,
                      "Id": "350d4654-cdd7-47c5-a638-2e4bf2307fd3",
                      "ParentId": "d292d409-2a17-4b7e-b4f8-9d247ed3d472",
                      "Title": "GMA Heat 入圍者特輯",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 78,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 12,
                      "CreateTime": "2025-04-15T16:27:07.56",
                      "LastEditTime": "2025-07-16T10:07:19.04",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "GMA Heat 榮耀金曲36",
                    "to": {
                      "MLIId": 180,
                      "MLId": 15,
                      "Id": "43b3ca93-5d8d-4b4d-8ba0-cd56f33f9b9d",
                      "ParentId": "d292d409-2a17-4b7e-b4f8-9d247ed3d472",
                      "Title": "GMA Heat 榮耀金曲36",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 79,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 13,
                      "CreateTime": "2025-04-15T16:27:37.793",
                      "LastEditTime": "2025-07-16T10:07:19.047",
                      "IsWinner": false
                    }
                  }
                ]
              },
              {
                "title": "典禮地點",
                "to": {
                  "MLIId": 158,
                  "MLId": 15,
                  "Id": "fa5b980d-3760-4b56-94a2-e27b5b64963c",
                  "ParentId": "202534c5-ad56-429c-bc42-bc3f52639d51",
                  "Title": "典禮地點",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 2,
                  "CId": -1,
                  "PId": 348,
                  "Url": "",
                  "Blank": false,
                  "Sort": 14,
                  "CreateTime": "2025-04-14T21:07:04.38",
                  "LastEditTime": "2025-07-16T10:07:19.053",
                  "IsWinner": false
                },
                "subSubMenu": []
              }
            ]
          },
          {
            "title": "金曲國際音樂節",
            "subMenu": [
              {
                "title": "活動日程表",
                "to": {
                  "MLIId": 160,
                  "MLId": 15,
                  "Id": "fa1d09e5-704d-4029-8a38-dd9f7c6fcf5c",
                  "ParentId": "f3803649-fa6b-4c75-9c46-5943ab467b21",
                  "Title": "活動日程表",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 90,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 16,
                  "CreateTime": "2025-04-15T10:07:01.053",
                  "LastEditTime": "2025-07-16T10:07:19.063",
                  "IsWinner": false
                },
                "subSubMenu": []
              },
              {
                "title": "系列活動",
                "to": {
                  "MLIId": 161,
                  "MLId": 15,
                  "Id": "6c2df16a-1668-4359-8316-e20d789b984e",
                  "ParentId": "f3803649-fa6b-4c75-9c46-5943ab467b21",
                  "Title": "系列活動",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 3,
                  "CId": -1,
                  "PId": -1,
                  "Url": "/gma/36th/#/Festival/",
                  "Blank": false,
                  "Sort": 17,
                  "CreateTime": "2025-04-15T10:07:11.077",
                  "LastEditTime": "2025-07-16T10:07:19.07",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "音樂論壇",
                    "to": {
                      "MLIId": 162,
                      "MLId": 15,
                      "Id": "65f1faba-5092-432d-85b7-57cccccdf27b",
                      "ParentId": "6c2df16a-1668-4359-8316-e20d789b984e",
                      "Title": "音樂論壇",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 59,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 18,
                      "CreateTime": "2025-04-15T10:07:19.497",
                      "LastEditTime": "2025-07-16T10:07:19.077",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "商務交流會",
                    "to": {
                      "MLIId": 164,
                      "MLId": 15,
                      "Id": "1b33570e-b298-47b4-9fb6-b2248d7d9899",
                      "ParentId": "6c2df16a-1668-4359-8316-e20d789b984e",
                      "Title": "商務交流會",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 68,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 19,
                      "CreateTime": "2025-04-15T10:07:36.063",
                      "LastEditTime": "2025-07-16T10:07:19.083",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "商務媒合會",
                    "to": {
                      "MLIId": 165,
                      "MLId": 15,
                      "Id": "c4b275b3-09dc-4c5b-a691-d9cdc6865e8b",
                      "ParentId": "6c2df16a-1668-4359-8316-e20d789b984e",
                      "Title": "商務媒合會",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 130,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 20,
                      "CreateTime": "2025-04-15T10:07:45.2",
                      "LastEditTime": "2025-07-16T10:07:19.09",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "商展交易中心",
                    "to": {
                      "MLIId": 166,
                      "MLId": 15,
                      "Id": "26465a2a-bec0-4625-99e5-5896762d2077",
                      "ParentId": "6c2df16a-1668-4359-8316-e20d789b984e",
                      "Title": "商展交易中心",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 2,
                      "CId": 70,
                      "PId": 285,
                      "Url": "",
                      "Blank": false,
                      "Sort": 21,
                      "CreateTime": "2025-04-15T10:07:49.713",
                      "LastEditTime": "2025-07-16T10:07:19.093",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "SHOWCASE售票演唱會",
                    "to": {
                      "MLIId": 167,
                      "MLId": 15,
                      "Id": "fa11dbdb-4578-4267-b9c2-0eeaaf9f88a6",
                      "ParentId": "6c2df16a-1668-4359-8316-e20d789b984e",
                      "Title": "SHOWCASE售票演唱會",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 52,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 22,
                      "CreateTime": "2025-04-15T10:07:50.87",
                      "LastEditTime": "2025-07-16T10:07:19.1",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "國際音樂節交流計畫",
                    "to": {
                      "MLIId": 168,
                      "MLId": 15,
                      "Id": "06dabfd3-b1a2-49f1-a11c-0c0975618134",
                      "ParentId": "6c2df16a-1668-4359-8316-e20d789b984e",
                      "Title": "國際音樂節交流計畫",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 61,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 23,
                      "CreateTime": "2025-04-15T10:07:51.827",
                      "LastEditTime": "2025-07-16T10:07:19.107",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "金曲36入圍新人演出",
                    "to": {
                      "MLIId": 169,
                      "MLId": 15,
                      "Id": "20ed5f1c-6752-4a0c-b19a-cf859e8e5d82",
                      "ParentId": "6c2df16a-1668-4359-8316-e20d789b984e",
                      "Title": "金曲36入圍新人演出",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 62,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 24,
                      "CreateTime": "2025-04-15T10:07:52.827",
                      "LastEditTime": "2025-07-16T10:07:19.11",
                      "IsWinner": false
                    }
                  }
                ]
              },
              {
                "title": "場地資訊",
                "to": {
                  "MLIId": 171,
                  "MLId": 15,
                  "Id": "649ddfc7-4b4e-4270-9b60-3ddee78dd703",
                  "ParentId": "f3803649-fa6b-4c75-9c46-5943ab467b21",
                  "Title": "場地資訊",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 51,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 25,
                  "CreateTime": "2025-04-15T10:08:40.69",
                  "LastEditTime": "2025-07-16T10:07:19.117",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "台北寒舍艾美酒店",
                    "to": {
                      "MLIId": 172,
                      "MLId": 15,
                      "Id": "7ff46832-4d6c-48d0-bacc-776ad6643ef0",
                      "ParentId": "649ddfc7-4b4e-4270-9b60-3ddee78dd703",
                      "Title": "台北寒舍艾美酒店",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 146,
                      "PId": 275,
                      "Url": "",
                      "Blank": false,
                      "Sort": 26,
                      "CreateTime": "2025-04-15T10:08:50.073",
                      "LastEditTime": "2025-07-16T10:07:19.123",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "Corner Max 大角落多功能展演館",
                    "to": {
                      "MLIId": 173,
                      "MLId": 15,
                      "Id": "e26da315-fa1f-40e9-aadd-f49ccfae0bb3",
                      "ParentId": "649ddfc7-4b4e-4270-9b60-3ddee78dd703",
                      "Title": "Corner Max 大角落多功能展演館",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 145,
                      "PId": 297,
                      "Url": "",
                      "Blank": false,
                      "Sort": 27,
                      "CreateTime": "2025-04-15T10:08:50.65",
                      "LastEditTime": "2025-07-16T10:07:19.13",
                      "IsWinner": false
                    }
                  }
                ]
              },
              {
                "title": "住宿資訊",
                "to": {
                  "MLIId": 174,
                  "MLId": 15,
                  "Id": "59c36cf7-eaa4-4407-a51e-761289e39c66",
                  "ParentId": "f3803649-fa6b-4c75-9c46-5943ab467b21",
                  "Title": "住宿資訊",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 65,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 28,
                  "CreateTime": "2025-04-15T10:09:06.697",
                  "LastEditTime": "2025-07-16T10:07:19.137",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "台北寒舍艾美酒店",
                    "to": {
                      "MLIId": 175,
                      "MLId": 15,
                      "Id": "d8ed3976-0407-44f9-9142-9dee52c81e78",
                      "ParentId": "59c36cf7-eaa4-4407-a51e-761289e39c66",
                      "Title": "台北寒舍艾美酒店",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 144,
                      "PId": 275,
                      "Url": "",
                      "Blank": false,
                      "Sort": 29,
                      "CreateTime": "2025-04-15T10:09:14.59",
                      "LastEditTime": "2025-07-16T10:07:19.14",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "台北艾麗酒店",
                    "to": {
                      "MLIId": 176,
                      "MLId": 15,
                      "Id": "11e927e9-e98b-463d-a21f-ea68f4003c3d",
                      "ParentId": "59c36cf7-eaa4-4407-a51e-761289e39c66",
                      "Title": "台北艾麗酒店",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 143,
                      "PId": 276,
                      "Url": "",
                      "Blank": false,
                      "Sort": 30,
                      "CreateTime": "2025-04-15T10:09:15.37",
                      "LastEditTime": "2025-07-16T10:07:19.15",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "阿樹國際旅店",
                    "to": {
                      "MLIId": 791,
                      "MLId": 15,
                      "Id": "8d7cc34a-4b24-4a7e-8612-ceb52a6a2e94",
                      "ParentId": "59c36cf7-eaa4-4407-a51e-761289e39c66",
                      "Title": "阿樹國際旅店",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 154,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 31,
                      "CreateTime": "2025-06-13T02:00:26.14",
                      "LastEditTime": "2025-07-16T10:07:19.153",
                      "IsWinner": false
                    }
                  }
                ]
              }
            ]
          }
        ],
        "RightTop_Menu": [
          {
            "Menu": {
              "MLIId": 112,
              "MLId": 10,
              "Id": "3d73843c-c0cc-47c5-8ccc-59d2c89e966e",
              "ParentId": "root",
              "Title": "網站導覽",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "/gma/36th/#/SiteMap",
              "Blank": false,
              "Sort": 1,
              "CreateTime": "2025-04-01T14:28:47.773",
              "LastEditTime": "2025-05-06T17:32:00.877",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 136,
              "MLId": 10,
              "Id": "e0ac26c3-d513-4a53-828f-1df6fa79ea57",
              "ParentId": "root",
              "Title": "最新消息",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 1,
              "CId": 80,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 2,
              "CreateTime": "2025-04-11T09:23:01.233",
              "LastEditTime": "2025-05-06T17:32:00.877",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 239,
              "MLId": 10,
              "Id": "0c2027d6-5996-4585-9f8d-0766c7f0fe26",
              "ParentId": "root",
              "Title": "媒體報名",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://register.gmanetwork.tw/mediagroup/default.asp",
              "Blank": true,
              "Sort": 3,
              "CreateTime": "2025-04-22T15:05:47.783",
              "LastEditTime": "2025-05-06T17:32:00.89",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 240,
              "MLId": 10,
              "Id": "e48ba348-7d3d-4f46-a41c-3516a7fccfc2",
              "ParentId": "root",
              "Title": "廠商專區",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://register.gmanetwork.tw/gm36/member/signin.aspx",
              "Blank": true,
              "Sort": 4,
              "CreateTime": "2025-04-22T15:07:08.133",
              "LastEditTime": "2025-05-06T17:32:00.89",
              "IsWinner": false
            },
            "SubMenus": null
          }
        ],
        "Right_Menu": [
          {
            "Menu": {
              "MLIId": 63,
              "MLId": 4,
              "Id": "01a8486d-8d8b-4da7-8386-f9a2cfc42c22",
              "ParentId": "root",
              "Title": "Facebook",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/88b27330-b456-4f39-8a4a-75ed4f612537.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.facebook.com/GMAGMF",
              "Blank": true,
              "Sort": 1,
              "CreateTime": "2025-03-31T10:08:36.087",
              "LastEditTime": "2025-04-30T14:10:02.67",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 64,
              "MLId": 4,
              "Id": "e7264c42-d9a2-46e5-85d8-b6651610b974",
              "ParentId": "root",
              "Title": "Youtube",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/7bbcd1c0-6985-4584-803a-1e66aec01ed7.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.youtube.com/channel/UC_r0QUJ6T4ZLaadqQcaA7qw",
              "Blank": true,
              "Sort": 2,
              "CreateTime": "2025-03-31T10:08:55.803",
              "LastEditTime": "2025-04-30T14:10:02.687",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 65,
              "MLId": 4,
              "Id": "733bb800-2d91-47c9-82e0-16db30c14c07",
              "ParentId": "root",
              "Title": "X",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/ad94543c-3a93-444d-a891-824a6c21ed23.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://twitter.com/GoldenMelody",
              "Blank": true,
              "Sort": 3,
              "CreateTime": "2025-03-31T10:09:09.1",
              "LastEditTime": "2025-04-30T14:10:02.687",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 66,
              "MLId": 4,
              "Id": "07c5eff5-5345-4d45-a276-60e65994ef43",
              "ParentId": "root",
              "Title": "IG",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/ce224894-6171-41e5-93f8-b590fa203310.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.instagram.com/gmamusic.official/?hl=zh-tw",
              "Blank": true,
              "Sort": 4,
              "CreateTime": "2025-03-31T10:09:24.147",
              "LastEditTime": "2025-04-30T14:10:02.687",
              "IsWinner": false
            },
            "SubMenus": null
          }
        ]
      };
    } else {
      this.HeadData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "Header_Menu": [
          {
            "title": " Golden Melody Awards",
            "subMenu": [
              {
                "title": "Awards Ceremony",
                "to": {
                  "MLIId": 182,
                  "MLId": 16,
                  "Id": "c85f6ab7-072f-40f8-a152-9f33b4ad9f0a",
                  "ParentId": "eb601a26-f318-42c3-a568-da4be0e4265a",
                  "Title": "Awards Ceremony",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 3,
                  "CId": 108,
                  "PId": -1,
                  "Url": "/gma/36th/#/Awards",
                  "Blank": false,
                  "Sort": 2,
                  "CreateTime": "2025-04-17T11:25:30.33",
                  "LastEditTime": "2025-06-16T06:03:04.93",
                  "IsWinner": false
                },
                "subSubMenu": []
              },
              {
                "title": "Nomination",
                "to": {
                  "MLIId": 183,
                  "MLId": 16,
                  "Id": "4a209cf2-4b38-4c87-a347-6aed92f2a316",
                  "ParentId": "eb601a26-f318-42c3-a568-da4be0e4265a",
                  "Title": "Nomination",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 3,
                  "CId": 109,
                  "PId": -1,
                  "Url": "/gma/36th/#/Awards/AwardWinners",
                  "Blank": false,
                  "Sort": 3,
                  "CreateTime": "2025-04-17T11:25:55.43",
                  "LastEditTime": "2025-06-16T06:03:04.937",
                  "IsWinner": false
                },
                "subSubMenu": []
              },
              {
                "title": "Getting here",
                "to": {
                  "MLIId": 184,
                  "MLId": 16,
                  "Id": "fd667564-1d3a-4c72-a7c5-3aeebd1b12d8",
                  "ParentId": "eb601a26-f318-42c3-a568-da4be0e4265a",
                  "Title": "Getting here",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 2,
                  "CId": 110,
                  "PId": 383,
                  "Url": "",
                  "Blank": false,
                  "Sort": 4,
                  "CreateTime": "2025-04-17T11:26:32.697",
                  "LastEditTime": "2025-06-16T06:03:04.94",
                  "IsWinner": false
                },
                "subSubMenu": []
              }
            ]
          },
          {
            "title": "Golden Melody Festival",
            "subMenu": [
              {
                "title": "Schedule",
                "to": {
                  "MLIId": 187,
                  "MLId": 16,
                  "Id": "72930aec-34a1-4bb9-9142-355338115298",
                  "ParentId": "ad7fd26a-dcc5-4f25-af7b-15b8683fbde4",
                  "Title": "Schedule",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 111,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 6,
                  "CreateTime": "2025-04-17T11:27:18.21",
                  "LastEditTime": "2025-06-16T06:03:04.953",
                  "IsWinner": false
                },
                "subSubMenu": []
              },
              {
                "title": "Events",
                "to": {
                  "MLIId": 188,
                  "MLId": 16,
                  "Id": "49420c13-7403-4a1a-a3ec-aa519e77898b",
                  "ParentId": "ad7fd26a-dcc5-4f25-af7b-15b8683fbde4",
                  "Title": "Events",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 3,
                  "CId": 112,
                  "PId": -1,
                  "Url": "/gma/36th/#/Festival/",
                  "Blank": false,
                  "Sort": 7,
                  "CreateTime": "2025-04-17T11:27:29.86",
                  "LastEditTime": "2025-06-16T06:03:04.96",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "Conference",
                    "to": {
                      "MLIId": 191,
                      "MLId": 16,
                      "Id": "64bc2d60-32f1-467a-ac38-c1f221ca08b7",
                      "ParentId": "49420c13-7403-4a1a-a3ec-aa519e77898b",
                      "Title": "Conference",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 113,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 8,
                      "CreateTime": "2025-04-17T11:28:56.47",
                      "LastEditTime": "2025-06-16T06:03:04.963",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "Speed Meeting",
                    "to": {
                      "MLIId": 192,
                      "MLId": 16,
                      "Id": "64b0fd27-e719-4b65-947e-8713a311c252",
                      "ParentId": "49420c13-7403-4a1a-a3ec-aa519e77898b",
                      "Title": "Speed Meeting",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 114,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 9,
                      "CreateTime": "2025-04-17T11:34:09.247",
                      "LastEditTime": "2025-06-16T06:03:04.97",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "Pitching",
                    "to": {
                      "MLIId": 193,
                      "MLId": 16,
                      "Id": "5d50c7a1-fb3d-4dbd-bd4c-054267803cae",
                      "ParentId": "49420c13-7403-4a1a-a3ec-aa519e77898b",
                      "Title": "Pitching",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 134,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 10,
                      "CreateTime": "2025-04-17T11:34:35.76",
                      "LastEditTime": "2025-06-16T06:03:04.98",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "Biz Matching Center",
                    "to": {
                      "MLIId": 194,
                      "MLId": 16,
                      "Id": "39be5822-b481-437a-8898-3d28625bd768",
                      "ParentId": "49420c13-7403-4a1a-a3ec-aa519e77898b",
                      "Title": "Biz Matching Center",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 2,
                      "CId": -1,
                      "PId": 397,
                      "Url": "",
                      "Blank": false,
                      "Sort": 11,
                      "CreateTime": "2025-04-17T11:34:47.443",
                      "LastEditTime": "2025-06-16T06:03:04.983",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "SHOWCASE",
                    "to": {
                      "MLIId": 195,
                      "MLId": 16,
                      "Id": "eeb4243f-0777-4e2b-b7c6-a152bacc4dc2",
                      "ParentId": "49420c13-7403-4a1a-a3ec-aa519e77898b",
                      "Title": "SHOWCASE",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 116,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 12,
                      "CreateTime": "2025-04-17T11:34:59.153",
                      "LastEditTime": "2025-06-16T06:03:04.99",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "GMA Partnerships",
                    "to": {
                      "MLIId": 196,
                      "MLId": 16,
                      "Id": "50173caa-532b-4fbd-bbdc-6c6a7f3bfdd1",
                      "ParentId": "49420c13-7403-4a1a-a3ec-aa519e77898b",
                      "Title": "GMA Partnerships",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 118,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 13,
                      "CreateTime": "2025-04-17T11:35:16.797",
                      "LastEditTime": "2025-06-16T06:03:04.997",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "36th GMA Best New Artist Nominees Performances",
                    "to": {
                      "MLIId": 197,
                      "MLId": 16,
                      "Id": "8c6f38e0-5497-4813-85b6-cf22b42182e7",
                      "ParentId": "49420c13-7403-4a1a-a3ec-aa519e77898b",
                      "Title": "36th GMA Best New Artist Nominees Performances",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 152,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 14,
                      "CreateTime": "2025-04-17T11:36:05.13",
                      "LastEditTime": "2025-06-16T06:03:05",
                      "IsWinner": false
                    }
                  }
                ]
              },
              {
                "title": "Venue Information",
                "to": {
                  "MLIId": 189,
                  "MLId": 16,
                  "Id": "c2df1479-42a1-4298-a52b-4eff3951633f",
                  "ParentId": "ad7fd26a-dcc5-4f25-af7b-15b8683fbde4",
                  "Title": "Venue Information",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 119,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 15,
                  "CreateTime": "2025-04-17T11:27:37.44",
                  "LastEditTime": "2025-06-16T06:03:05.007",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "Le Méridien Taipei",
                    "to": {
                      "MLIId": 241,
                      "MLId": 16,
                      "Id": "b831271d-221e-44f1-ae26-bf79dad40979",
                      "ParentId": "c2df1479-42a1-4298-a52b-4eff3951633f",
                      "Title": "Le Méridien Taipei",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 120,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 16,
                      "CreateTime": "2025-04-25T14:16:40.277",
                      "LastEditTime": "2025-06-16T06:03:05.013",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "Corner Max ",
                    "to": {
                      "MLIId": 243,
                      "MLId": 16,
                      "Id": "4c63518b-f6b7-4f3f-bd1c-20596d11e54c",
                      "ParentId": "c2df1479-42a1-4298-a52b-4eff3951633f",
                      "Title": "Corner Max ",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 121,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 17,
                      "CreateTime": "2025-04-25T14:18:20.41",
                      "LastEditTime": "2025-06-16T06:03:05.02",
                      "IsWinner": false
                    }
                  }
                ]
              },
              {
                "title": "Accommodation information",
                "to": {
                  "MLIId": 190,
                  "MLId": 16,
                  "Id": "3be9ae8e-f1c5-4422-8226-2b4a4a9abc1d",
                  "ParentId": "ad7fd26a-dcc5-4f25-af7b-15b8683fbde4",
                  "Title": "Accommodation information",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 123,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 18,
                  "CreateTime": "2025-04-17T11:27:47.267",
                  "LastEditTime": "2025-06-16T06:03:05.023",
                  "IsWinner": false
                },
                "subSubMenu": [
                  {
                    "title": "Le Méridien Taipei",
                    "to": {
                      "MLIId": 244,
                      "MLId": 16,
                      "Id": "b4be77c6-ec00-49df-a0a4-6af990044d8f",
                      "ParentId": "3be9ae8e-f1c5-4422-8226-2b4a4a9abc1d",
                      "Title": "Le Méridien Taipei",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 124,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 19,
                      "CreateTime": "2025-04-25T14:20:06.043",
                      "LastEditTime": "2025-06-16T06:03:05.03",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "Humble House",
                    "to": {
                      "MLIId": 245,
                      "MLId": 16,
                      "Id": "0ad3c14c-3264-4f6b-a467-22687b2c0c47",
                      "ParentId": "3be9ae8e-f1c5-4422-8226-2b4a4a9abc1d",
                      "Title": "Humble House",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 125,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 20,
                      "CreateTime": "2025-04-25T14:20:23.753",
                      "LastEditTime": "2025-06-16T06:03:05.037",
                      "IsWinner": false
                    }
                  },
                  {
                    "title": "arTree Hotel",
                    "to": {
                      "MLIId": 792,
                      "MLId": 16,
                      "Id": "79a7eadf-1261-4d98-979a-5278a5285c83",
                      "ParentId": "3be9ae8e-f1c5-4422-8226-2b4a4a9abc1d",
                      "Title": "arTree Hotel",
                      "Description": "",
                      "IsVisable": true,
                      "Image": "",
                      "Color": "",
                      "Type": 1,
                      "CId": 155,
                      "PId": -1,
                      "Url": "",
                      "Blank": false,
                      "Sort": 21,
                      "CreateTime": "2025-06-13T02:10:44.09",
                      "LastEditTime": "2025-06-16T06:03:05.04",
                      "IsWinner": false
                    }
                  }
                ]
              }
            ]
          }
        ],
        "RightTop_Menu": [
          {
            "Menu": {
              "MLIId": 290,
              "MLId": 20,
              "Id": "99a3fb9e-2692-4b2a-9863-46b67e6ffa5d",
              "ParentId": "root",
              "Title": "SiteMap",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "/gma/36th/#/SiteMap",
              "Blank": false,
              "Sort": 1,
              "CreateTime": "2025-04-30T12:30:16.26",
              "LastEditTime": "2025-04-30T16:25:04.3",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 291,
              "MLId": 20,
              "Id": "5bab1235-0cbc-42b8-bb11-c8c1e1536547",
              "ParentId": "root",
              "Title": "News",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 1,
              "CId": 127,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 2,
              "CreateTime": "2025-04-30T12:30:25.76",
              "LastEditTime": "2025-04-30T16:25:04.3",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 300,
              "MLId": 20,
              "Id": "abaabc03-3aef-4648-9ac9-95f0c4be2298",
              "ParentId": "root",
              "Title": "Media Registration",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://register.gmanetwork.tw/mediagroup/default_en.asp",
              "Blank": true,
              "Sort": 3,
              "CreateTime": "2025-04-30T14:10:00.37",
              "LastEditTime": "2025-04-30T16:25:04.3",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 301,
              "MLId": 20,
              "Id": "aaadd195-3a2f-44c9-8085-f1a7e97a55e0",
              "ParentId": "root",
              "Title": "VIP Login",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://register.gmanetwork.tw/gm36/member/signin.aspx?lang=en",
              "Blank": true,
              "Sort": 4,
              "CreateTime": "2025-04-30T14:11:04.31",
              "LastEditTime": "2025-04-30T16:25:04.3",
              "IsWinner": false
            },
            "SubMenus": null
          }
        ],
        "Right_Menu": [
          {
            "Menu": {
              "MLIId": 295,
              "MLId": 24,
              "Id": "90549816-2f68-40c3-aae9-6e5c9d7fc6bd",
              "ParentId": "root",
              "Title": "Facebook",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/ce7d3f30-0234-4c66-8cc1-1298c184ca1c.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.facebook.com/GMAGMF",
              "Blank": true,
              "Sort": 1,
              "CreateTime": "2025-04-30T14:07:14.247",
              "LastEditTime": "2025-04-30T14:27:08.097",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 296,
              "MLId": 24,
              "Id": "eded6482-e9e7-44c0-8e5d-dc1840868627",
              "ParentId": "root",
              "Title": "Youtube",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/d4d197de-85c0-4b14-bad0-c88036840944.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.youtube.com/channel/UC_r0QUJ6T4ZLaadqQcaA7qw",
              "Blank": true,
              "Sort": 2,
              "CreateTime": "2025-04-30T14:07:23.437",
              "LastEditTime": "2025-04-30T14:27:08.097",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 297,
              "MLId": 24,
              "Id": "6546105e-eb10-4d8b-89bc-a1d5d845a80b",
              "ParentId": "root",
              "Title": "X",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/6594b620-c776-42a6-a5da-ce51f9fda211.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://twitter.com/GoldenMelody",
              "Blank": true,
              "Sort": 3,
              "CreateTime": "2025-04-30T14:07:41.657",
              "LastEditTime": "2025-04-30T14:27:08.113",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 298,
              "MLId": 24,
              "Id": "969892e2-7220-4611-9558-95118a6d616e",
              "ParentId": "root",
              "Title": "IG",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/302967d7-81bf-47e1-aa93-08b82370dcf8.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.instagram.com/gmamusic.official/?hl=zh-tw",
              "Blank": true,
              "Sort": 4,
              "CreateTime": "2025-04-30T14:07:56.473",
              "LastEditTime": "2025-04-30T14:27:08.113",
              "IsWinner": false
            },
            "SubMenus": null
          }
        ]
      };
    }
    this.menuItems = this.HeadData.Header_Menu;
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
    // let that = this;
    // // 監聽頁面滾動
    // window.addEventListener('scroll', function () {
    //   // 判斷滾動高度，若大於100px則顯示top-bar按鈕
    //   if (window.scrollY > 500) {
    //     that.isFloat = true;
    //   } else {
    //     that.isFloat = false;
    //   }
    // });

    setTimeout(() => {
      const headerHeight = this.$refs.header.offsetHeight;
      this.$refs.target.style.height = `${headerHeight}px`;
    }, 100); // 可調整時間
  },
  methods: {
    toggleMenuItem(index) {
      if (this.isMenuItemVisible[index]) {
        this.$set(this.isMenuItemVisible, index, false);
        this.activeIndex = null;
      } else {
        this.isMenuItemVisible = this.isMenuItemVisible.map(() => false);
        this.$set(this.isMenuItemVisible, index, true);
        this.activeIndex = index;
      }
      if (index === 1) {
        this.isParentActive = true;
      } else {
        this.isParentActive = false;
      }
    },
    toggleMenuItem_focusin(index) {
      this.toggleMenuItem(index);
    },
    closureMenuItem() {
      this.isMenuItemVisible = this.isMenuItemVisible.map(() => false);
      this.activeIndex = null;
    },

    closureMenu() {
      this.isMenuItemVisible = this.isMenuItemVisible.map(() => false);
      this.activeIndex = null;

      setTimeout(() => {
        const header = this.$refs.header;
        const target = this.$refs.target;

        if (header && target) {
          const height = header.offsetHeight;
          target.style.height = `${height}px`;
        }
      }, 300); // 300ms 視動畫速度調整
    },
    changeLang(lang) {
      $cookies.set("gma_the_site_lang", lang, "30d");
      //location.reload();
      this.$router.push({
        name: "Enter",
      });
    },
    gotoCategoryByCId: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
      //this.$router.push("/Category/" + CId);
    },
    gotoPostByPId: function (PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
    goto: function (MenuData) {
      if (MenuData.Type == 1) {
        this.closureMenu();
        this.gotoCategoryByCId(MenuData.CId);
      } else if (MenuData.Type == 2) {
        this.closureMenu();
        this.gotoPostByPId(MenuData.PId);
      } else if (MenuData.Type == 3) {
        this.closureMenu();
        this.gotoUrl(MenuData.Url, MenuData.Blank);
      }
    },
    getLink: function (MenuData) {
      if (MenuData.Type == 1) {
        const routeData = this.$router.resolve({
          name: "Category",
          params: { CId: MenuData.CId },
        });
        return routeData.href;
      } else if (MenuData.Type == 2) {
        const routeData = this.$router.resolve({
          name: "Post",
          params: { PId: MenuData.PId },
        });
        return routeData.href;
      } else if (MenuData.Type == 3) {
        return MenuData.Url;
      }
      return 'javascript:void(0)';
    },
  },
};
</script>